import {
    DE_PSEUDO_CARE_PROVIDER_FAILURE,
} from 'Redux/Action';
import { ArrayContains } from 'ClientService';

export const isCareProviderDePseudoFailed = (state) => ArrayContains(state.careProvider.failedRequests, [
    DE_PSEUDO_CARE_PROVIDER_FAILURE,
]);